import React from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "formik";
import { Grid } from "@material-ui/core";

import { TextInput, IntegerInput } from "../../../Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";

const LabelGrid = styled(Grid)`
  && {
    width: 200px;
  }
`;

const FormGrid = styled(Grid)`
  min-height: 40px;
  margin-left: 30px !important;
  width: 645px !important;
  border-bottom: ${props => (props.hasBorder ? "1px solid gainsboro" : "")};
`;

const Label = styled.div`
  font-size:17px !important;
  font-weight:bold;
  color: rgb(51,51,51)
  min-width:200px;
`;

const IndentedSideLabelIntegerWithRefInput = ({ label, fieldName, placeholder, formik, isDisabled, hasBorder, indentation, shouldHideForQuote, shouldHideRef, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);
  const refVal = _.get(formik.values, `${fieldName}Ref`);

  if (shouldHideForQuote) {
    return null;
  }

  return (
    <Grid container item alignItems="center" justify="flex-start" style={{ paddingLeft: indentation }}>
      <LabelGrid container item alignItems="flex-start">
        <Label>{label}</Label>
      </LabelGrid>
      <FormGrid hasBorder={hasBorder} container item alignItems="center">
        {isDisabled && (
          <Grid container item spacing={16}>
            <Grid item style={{ width: shouldHideRef ? (716 - indentation) : 597 - indentation }}>
              <ViewOnlyDiv>{val || ""}</ViewOnlyDiv>
            </Grid>
            {!shouldHideRef &&
              <Grid item style={{ width: 119 }}>
                <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
              </Grid>}
          </Grid>
        )}
        {!isDisabled && (
          <Grid container item spacing={16}>
            <Grid item style={{ width: shouldHideRef ? (716 - indentation) : 536 - indentation }}>
              <IntegerInput fullWidth fieldName={fieldName} placeholder={placeholder} {...otherProps} />
            </Grid>
            {!shouldHideRef &&
              <Grid item style={{ width: 180 }}>
                <TextInput fullWidth fieldName={`${fieldName}Ref`} placeholder="Add a reference" {...otherProps} />
              </Grid>}
          </Grid>
        )}
      </FormGrid>
    </Grid>
  );
};

export default connect(IndentedSideLabelIntegerWithRefInput);
